import { LocaleValuesFragment } from 'src/generated/operations.ts';

export const composeValue = (value: LocaleValuesFragment | null | undefined | string): string => {
    if (typeof value === 'string') {
        return value;
    }
    if (value === undefined || value === null) {
        return '';
    }
    return Array.isArray(value?.localized) ? value?.localized.join(', ') : `${value?.localized || ''}`;
};
